// get accounts from graphql and show currencies using small-dropdown
import { useCallback, useMemo } from 'react'

import { useAccounts, UseAccountsReturn } from '../../hooks/use-accounts'
import { SmallDropdown } from '../small-dropdown'

export function CurrencySelector(props: any) {
    const { groupedByAccounts } = useAccounts({
        type: undefined,
        groupBy: ['amount', 'currency'],
        currency: undefined,
    }) as UseAccountsReturn

    // get keys of the object and remove duplicated
    const getUniqueCurrencies = useCallback((obj: any) => {
        const keys = Object.keys(obj)
        const uniqueKeys = [] as any[]
        for (const key of keys) {
            if (uniqueKeys.indexOf(key) === -1) {
                uniqueKeys.push(key)
            }
        }
        return [
            { label: 'All Accounts', value: undefined },
            ...uniqueKeys.map(key => ({
                label: `${key} accounts`,
                value: key,
            })),
        ]
    }, [])

    const currencies = useMemo(() => {
        return getUniqueCurrencies(groupedByAccounts)
    }, [groupedByAccounts, getUniqueCurrencies])

    return <SmallDropdown options={currencies} {...props} />
}
